export type PendingAuthMode = "login" | "register";

const PENDING_AUTH_MODE_KEY = "softiqPendingAuthMode";

export function storePendingAuthMode(mode: PendingAuthMode) {
  try {
    window.sessionStorage.setItem(PENDING_AUTH_MODE_KEY, mode);
  } catch {
    // React context remains the fallback when storage is unavailable.
  }
}

export function consumePendingAuthMode(): PendingAuthMode | null {
  try {
    const mode = window.sessionStorage.getItem(PENDING_AUTH_MODE_KEY);
    window.sessionStorage.removeItem(PENDING_AUTH_MODE_KEY);
    return mode === "login" || mode === "register" ? mode : null;
  } catch {
    return null;
  }
}
